import React from 'react'
import Lottie from 'react-lottie-player'

import * as animationData from '../animations/page_loading.json'

const PageLoader = () => {
    return (
        <div className="flex justify-center h-screen items-center">
            <Lottie
                loop
                animationData={animationData}
                play
                style={{ width: 150, height: 150 }}
            />
        </div>
    )
}

export default PageLoader
